import { Box } from '@wix/design-system';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import React, { FunctionComponent, useEffect } from 'react';

import { DATA_HOOKS } from '../../dataHooks';
import { useStore } from '../../zustand/stores';

const LoaderVideo = dynamic(() => import('./LoaderVideo'), { ssr: false });
import css from './index.module.scss';

type LoaderProps = {
  isSticky?: boolean;
};

const Loader: FunctionComponent<LoaderProps> = ({ isSticky }) => {
  const { skipGlobalLoader, setSkipGlobalLoader } = useStore(state => state.loaderSlice);

  useEffect(() => {
    if (isSticky) {
      setSkipGlobalLoader(true);
    }

    return () => {
      if (isSticky) {
        setSkipGlobalLoader(false);
      }
    };
  }, []);


  if (skipGlobalLoader && !isSticky) {
    return null;
  }


  return (
    <Box
      className={classNames({ [css.wrapper]: !isSticky, [css.wrapperSticky]: isSticky })}
      dataHook={DATA_HOOKS.HC_LOADER}
      align='center'
      verticalAlign='middle'
      direction='vertical'
    >
      <LoaderVideo />
    </Box>
  );
};

export default Loader;
